var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("app-human-filter-list-edit", {
            attrs: { browse: _vm.browse, model: _vm.model },
            model: {
              value: _vm.value.Filters,
              callback: function ($$v) {
                _vm.$set(_vm.value, "Filters", $$v)
              },
              expression: "value.Filters",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }